module.exports = __webpack_public_path__ + "media/images/beauty/marie-claire@2x-639c9c5a4625134cc8191ef3862580b0.jpg";